import { Component, OnInit, ElementRef } from '@angular/core';
import { FormBuilder, NgForm, FormArray, FormControl } from '@angular/forms';
import { environment } from '../../../../environments/environment';
import { BreakdownService } from '../../../quote/breakdown/breakdown.service';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { QuoteService } from 'src/app/quote/quote.service';
import { formatDate } from '@angular/common';
import { LocalStorageService } from 'ngx-webstorage';

@Component({
  selector: 'app-breakdown-policy',
  templateUrl: './breakdown-policy.component.html',
  styleUrls: ['./breakdown-policy.component.css']
})

export class BreakdownPolicyComponent implements OnInit {
  private static readonly INPROGRESS_STATUS_ID = 'e216564f-552a-4e45-ae67-0a63b7074691';
  private static readonly QUOTED_STATUS_ID = '80c0db90-ba5d-4387-b09a-4c008a664932';
  private static readonly REFERRED_STATUS_ID = 'f6d14624-6351-4d93-b27b-70fb8a06ec5d';
  private static readonly DECLINED_STATUS_ID = 'dda8734c-d149-4336-b8cc-c2e205430752';
  private static readonly INSURED_STATUS_ID = '5c952313-48e7-4834-9890-b118635befea';
  private static readonly CANCELLED_INSURANCE_STATUS_ID = '7a877243-0919-4f92-8c35-6f5732013ca6';
  private static readonly LOST_STATUS_ID = 'd6d1ebc1-f35f-425e-8dee-cec371136e64';

  public staticData;
  public id = this.route.snapshot.params.quote_id;
  public authDetails: string = '';
  public quoteDetails;
  public policyID: string = '';
  public hasImportantNotes: boolean = false;
  public totalImpNotes: number = 0;
  public submitted: boolean = false;
  public cancellation_date;
  public cancellation_reason;
  public refund_amount;
  public minCancellationDate = new Date();
  public maxCancellationDate = new Date();
  public isAdmin: boolean = false;
  public BREAKDOWN_ID = '';
  public cancellationReasons = ['Vehicle Sold', 'Non Payment',  'Placed Elsewhere – Price Reason', 'Placed Elsewhere – Service Reason', 'Change of Mind', 'No Reason Given' , 'Insurer Enforced'];
  public statusLabel = '';
  public statusBadgeClass = 'badge-secondary';

  constructor(
    private breakdownService: BreakdownService, 
    private route: ActivatedRoute, 
    private router: Router, 
    private modalService: NgbModal,
    private quoteService: QuoteService, 
    private formBuilder: FormBuilder, 
    private el: ElementRef, 
    private sessionSt: LocalStorageService
  ) {}

  public ngOnInit(): void {
    this.getAccessToken();
    this.getQuote();
    this.BREAKDOWN_ID = environment.BREAKDOWN_ID;

    const minDate = new Date().setDate(new Date().getDate());
    this.minCancellationDate = new Date(minDate);

    const maxDate = new Date().setDate(new Date().getDate() + 30);
    this.maxCancellationDate = new Date(maxDate);

    if (this.sessionSt.retrieve('is_admin')) {
      this.isAdmin = true;
    }
  }

  public getAccessToken() {
    const data = {
      client_id: environment.AMLINE_CLIENT_ID,
      client_secret: environment.AMLINE_CLIENT_SECRET,
      grant_type: environment.AMLINE_GRANT_TYPE,
      scope: environment.AMLINE_SCOPE,
    };

    // get auth details
    this.breakdownService.getAccessToken(data)
      .subscribe((response: any) => {
        if (response.access_token) {
          this.authDetails = response;
          this.getStaticData(response);
        }
      });
  }

  public getStaticData(response) {
    this.breakdownService
      .getStaticData(response)
      .subscribe((response: any) => {
        if (response.meta) {
          this.staticData = response.meta;
        }
      });
  }

 // GET QUOTE DETAILS
 public getQuote() {
  this.breakdownService.getBreakdownQuoteDetailsByQuoteID(this.route.snapshot.params.quote_id)
    .subscribe(
      (response: any) => {
        console.log('Get quote: ', response);
        this.quoteDetails = response.result.quote;
        this.policyID = response.result.quote.id;
        this.quoteDetails.id = response.result.quote.id;
        this.quoteDetails.quoteMetaId = response.result.quote.quote_meta_id;
        this.quoteDetails.insurance_status_id = response.result.quote.insurance_status_id;
        this.quoteDetails.quote_meta_policy_status = response.result.quote.quote_meta_policy_status;
        this.quoteDetails.company_id = response.result.quote.company_id;
        this.quoteDetails.broker_name = response.result.quote.broker_name;
        this.quoteDetails.company_name = response.result.quote.policy_holder_detail.company_name;
        this.quoteDetails.is_send_email = response.result.quote.is_send_email;
        this.quoteDetails.type = response.result.quote.type;
        this.quoteDetails.broker_id = response.result.quote.broker_id;
        this.quoteDetails.notes = response.result.quote.notes;
        if (response.result.quote.financial_details) {
          this.quoteDetails.peliwica_fee = response.result.quote.financial_details.fees;
          this.quoteDetails.broker_commission = response.result.quote.financial_details.broker_commission;
          this.quoteDetails.broker_admin_fee = response.result.quote.financial_details.broker_admin_fee;
        } else {
          this.quoteDetails.peliwica_fee = 0;
          this.quoteDetails.broker_commission = 0;
          this.quoteDetails.broker_admin_fee = 0;
        }

        this.quoteDetails.email = response.result.quote.policy_holder_detail?.email;
        this.quoteDetails.phone = response.result.quote.policy_holder_detail?.phone;
        this.quoteDetails.is_email = response.result.quote.policy_holder_detail?.is_email;
        this.quoteDetails.is_phone = response.result.quote.policy_holder_detail?.is_phone;
        this.quoteDetails.sms = response.result.quote.policy_holder_detail?.sms;
        this.quoteDetails.post = response.result.quote.policy_holder_detail?.post;
        this.quoteDetails.affinity_partner = response.result.quote.affinity_partner;
        this.quoteDetails.transactional_date = response.result.quote.transactional_date;
        this.quoteDetails.is_paid = response.result.quote.is_paid;
        this.quoteDetails.product_id = response.result.quote.product_id;
        this.quoteDetails.is_policy = response.result.quote.is_policy;
        this.quoteDetails.policy_ref_number = response.result.quote.policy_ref_number;
        this.quoteDetails.policyRefNumber = response.result.quote.policy_ref_number;
        this.updateQuoteState();
        this.getQuoteNotes();
      },
    );
}

  private updateQuoteState(): void {
    if (!this.quoteDetails) {
      this.statusLabel = '';
      this.statusBadgeClass = 'badge-secondary';
      return;
    }
    const type = Number(this.quoteDetails.type);
    const metaPs = this.quoteDetails.quote_meta_policy_status;
    if (type === 4) {
      this.statusLabel = 'Cancelled';
      this.statusBadgeClass = 'badge-dark';
      return;
    }
    if (metaPs !== undefined && metaPs !== null && Number(metaPs) === 0) {
      this.statusLabel = 'Inactive';
      this.statusBadgeClass = 'badge-secondary';
      return;
    }
    const statusId = this.quoteDetails.insurance_status_id;
    if (statusId === BreakdownPolicyComponent.REFERRED_STATUS_ID) {
      this.statusLabel = 'Referred';
      this.statusBadgeClass = 'badge-warning';
    } else if (statusId === BreakdownPolicyComponent.QUOTED_STATUS_ID) {
      this.statusLabel = 'Quoted';
      this.statusBadgeClass = 'badge-success';
    } else if (statusId === BreakdownPolicyComponent.DECLINED_STATUS_ID) {
      this.statusLabel = 'Declined';
      this.statusBadgeClass = 'badge-danger';
    } else if (statusId === BreakdownPolicyComponent.INSURED_STATUS_ID) {
      this.statusLabel = 'Insured';
      this.statusBadgeClass = 'badge-primary';
    } else if (statusId === BreakdownPolicyComponent.CANCELLED_INSURANCE_STATUS_ID) {
      this.statusLabel = 'Cancelled';
      this.statusBadgeClass = 'badge-dark';
    } else if (statusId === BreakdownPolicyComponent.LOST_STATUS_ID) {
      this.statusLabel = 'Lost';
      this.statusBadgeClass = 'badge-secondary';
    } else if (statusId === BreakdownPolicyComponent.INPROGRESS_STATUS_ID) {
      this.statusLabel = 'In Progress';
      this.statusBadgeClass = 'badge-info';
    } else {
      this.statusLabel = 'In Progress';
      this.statusBadgeClass = 'badge-info';
    }
  }

  policyActionsVisible(): boolean {
    if (!this.quoteDetails || Number(this.quoteDetails.type) === 4) {
      return false;
    } 

    if (this.quoteDetails.insurance_status_id === BreakdownPolicyComponent.CANCELLED_INSURANCE_STATUS_ID) {
      return false;
    }
    const metaPs = this.quoteDetails.quote_meta_policy_status;
    if (metaPs !== undefined && metaPs !== null && Number(metaPs) === 0) {
      return false;
    }
    return true;
  }

  // Issue Quote
  public issueQuotePopup(issueQuoteModal) {
    this.modalService.open(issueQuoteModal, { centered: true });
  }

  issueQuote() {
    const data = {
      breakdown_quote_id: this.route.snapshot.params.quote_id
    };

    this.breakdownService
      .issueQuote(data)
      .subscribe(
        (res: any) => {
          if (res.success) {
            this.modalService.dismissAll();
            this.router.navigateByUrl('/policy-list');
          }
        });
  }

  /*
  * Get Notes
  */
  getQuoteNotes() {
    this.quoteService.getNotes(this.quoteDetails.id)
      .subscribe(
        (response: any) => {
          const impNotes = response.result.filter(x => x.is_important == 1);
          this.totalImpNotes = impNotes.length;
          if (impNotes.length > 0) {
            this.hasImportantNotes = true;
          }
        });
  }

  onhasImportantNotesChange(event) {
    this.hasImportantNotes = event;
    this.totalImpNotes = this.totalImpNotes + 1;
  }

  /*
  * Convert To MTA
  */
  policyActions(type) {
    this.router.navigateByUrl('/breakdown/quote/' + this.id + '/' + type);
  }

  /*
  * Cancel Policy Popup
  */
  cancelPolicy(cancelModal: any) {
    this.modalService.open(cancelModal, { centered: true });
  }

  errorMsg: string = '';
  public getReturnPremium() {
    this.errorMsg = null;
    if (!this.cancellation_date || !this.cancellation_reason || !this.quoteDetails?.quoteMetaId) {
      return;
    }
    this.refund_amount = null;
    const effectiveDate = formatDate(this.cancellation_date, 'yyyy-MM-dd', 'en-UK');
    const payload = { quote_meta_id: this.quoteDetails.quoteMetaId, effective_date: effectiveDate, type: 4}
    this.breakdownService.calculateMTAFinancials(payload).subscribe(
      (res: any) => {
        if (res?.success && res.mta_financials) {
          this.refund_amount = Math.abs(res.mta_financials.adjustment_display_total ?? 0);
        } else {
          this.errorMsg = res?.message || 'Unable to calculate refund';
        }
      },
      (err) => {
        this.errorMsg = err?.error?.message || err?.error?.errors?.[0]?.detail || 'Unable to calculate refund';
      });
  }

  onSubmitCancelPolicy() {
    this.submitted = true;
    
    if (!this.quoteDetails || !this.quoteDetails.policy_holder_detail) {
      this.errorMsg = 'Quote details not available';
      return;
    }

    const policyHolder = this.quoteDetails.policy_holder_detail;
    const address = policyHolder.address || {};

    const effectiveDate = formatDate(this.cancellation_date, 'yyyy-MM-dd', 'en-UK');
    const data = {
      "quote_data": {
        "id": this.quoteDetails.id,
        "company_id": this.quoteDetails.company_id,
        "policy_start_date": this.quoteDetails.inception_date || this.quoteDetails.policy_start_date,
        "policy_end_date": this.quoteDetails.cover_to || this.quoteDetails.policy_end_date,
        "effective_date": effectiveDate,
        "broker_id": this.quoteDetails.broker_id,
        "type": 4,
        "policy_ref_number": this.quoteDetails.policyRefNumber || this.quoteDetails.policy_ref_number,
        "old_policy_id": this.quoteDetails.oldPolicyId || this.quoteDetails.old_policy_id,
        "sequence_number": this.quoteDetails.sequenceNumber || this.quoteDetails.sequence_number,
        "quote_meta_id": this.quoteDetails.quoteMetaId || this.quoteDetails.quote_meta_id,
        "policy_holder": {
          "title": policyHolder.title || '',
          "first_name": policyHolder.first_name || '',
          "last_name": policyHolder.last_name || '',
          "email": policyHolder.email || '',
          "phone": policyHolder.phone || '',
          "mobile": policyHolder.mobile || '',
          "dob": policyHolder.dob || '',
          "company_name": policyHolder.company_name || '',
          "trading_name": policyHolder.trading_name || '',
          "proposer_type": policyHolder.proposer_type || '',
          "address": {
            "address1": address.address1 || '',
            "address2": address.address2 || '',
            "address3": address.address3 || '',
            "address4": address.address4 || '',
            "city": address.city || '',
            "country": address.country || "UK",
            "postcode": address.postcode || '',
          },
          "sms": policyHolder.sms || false,
          "post": policyHolder.post || false,
          "is_phone": policyHolder.is_phone || false,
          "is_email": policyHolder.is_email || false,
        },
        "meta": {
          "effective_date": effectiveDate,
          "reason": this.cancellation_reason,
          "return_premium": this.refund_amount,
        }
      }
    };

    this.breakdownService.getCancelPolicy(data, this.policyID, this.authDetails)
      .subscribe(
        (res: any) => {
          if (res) {
            this.modalService.dismissAll();
            this.getQuote();
          }
        }, err => {
          if (err.error.errors && err.error.errors.length > 0) {
            this.errorMsg = err.error.errors[0].detail;
          }
        });
  }

  displayEmailView: boolean = false;
  displayNewEmailView: boolean = false;
  newEmailView() {
    this.displayNewEmailView = true;
  }

  emailId: string = '';
  getEmailView(emailId: string) {
    this.emailId = emailId;
    this.displayEmailView = true;
  }
  backToEmailsList() {
    this.displayEmailView = false;
    this.displayNewEmailView = false;
  }
}
